// confirm modal
export const SET_CONFIRM_MODAL_ID = 'SET_CONFIRM_MODAL_ID'
export const SET_CONFIRM_MODAL_IS_VISIBLE = 'SET_CONFIRM_MODAL_IS_VISIBLE'
export const SET_CONFIRM_MODAL_TITLE = 'SET_CONFIRM_MODAL_TITLE'
export const SET_CONFIRM_MODAL_MESSAGE = 'SET_CONFIRM_MODAL_MESSAGE'
export const SET_CONFIRM_MODAL_CALLBACK = 'SET_CONFIRM_MODAL_CALLBACK'

// fullscreen modal
export const SET_FULLSCREEN_MODAL_ID = 'SET_FULLSCREEN_MODAL_ID'

// overlay
export const SET_OVERLAY_ID = 'SET_OVERLAY_ID'



// WEBPACK FOOTER //
// ./src/store/modules/common/types.js